/**
 * In-memory access token mirrored from {@link AuthProvider} so API/SSE callers avoid
 * `supabase.auth.getSession()` on every request (cross-tab navigator.locks contention).
 */
let cachedAccessToken: string | null = null;
const accessTokenListeners = new Set<(token: string | null) => void>();

export function setHubCachedAccessToken(token: string | null): void {
  if (cachedAccessToken === token) {
    return;
  }
  cachedAccessToken = token;
  for (const listener of accessTokenListeners) {
    listener(token);
  }
}

export function getHubCachedAccessToken(): string | null {
  return cachedAccessToken;
}

export function onHubCachedAccessTokenChange(
  listener: (token: string | null) => void,
): () => void {
  accessTokenListeners.add(listener);
  return () => {
    accessTokenListeners.delete(listener);
  };
}
